export const grids = {
  P: {
    text: '{{ editor.panel.grids | polyglot }}',
    margin: '0 - Z2',
    userSelect: 'none',
    color: 'inactive',
    fontSize: 'Y',
    textTransform: 'uppercase'
  }
}
